import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../assets/css/icons.css';
import '../assets/css/style.css'
import '../assets/css/Buynow.css'
import loginbg from '../assets/images/login-bg.png';
import logo from '../assets/images/simulanis.png'
// import logo from '../assets/images/logo.svg'
import honeywell from '../assets/images/honeywell.png'
import { SERVER_IP, PORT, auth_response_flow } from '../Server';
import swal from 'sweetalert';
import axios from 'axios';
import $ from 'jquery';

class BuyNow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPackageSelected: false,
            password: "",
            cname: '',
            phone: '',
            logo: '',
            city: '',
            zip: '',
            address: '',
            details: '',
            stateAddress: '',
            c_a_name: '',
            packageSelected: "",
            errors: {
                cname: '',
                email: '',
                cpassword: '',
                password: '',
                c_a_name: '',
                location: ''

            },
            locationsList: [],
            location: 0,
            free_pkg: {
                app_manager: {
                    total_sites: 2,
                    total_users: 5,
                    duration: 30,
                    total_storage: 1073741824,
                    storage_type : "LIMITED"

                },
                dashboard: {
                    enable_themes: 0,
                    enable_analytics: 0,
                    enable_updates: 0
                },
                hardware: {
                    enable_android: 1,
                    enable_ios: 0,
                    enable_desktop: 0,
                    enable_hololens: 0,
                    enable_realwear: 1
                },
                features: {
                    enable_workflow: 1,
                    enable_myassist: 0,
                    enable_recorder: 0,
                    enable_viewer: 0
                },
                workflow: {
                    workflow_total: 5,
                    workflow_steps_total: 5,
                    enable_evidence: 1,
                    enable_local_save: 1,
                    enable_without_watermark: 1
                },
                myassist: {
                    enable_con_call: 1,
                    enable_annotation: 1,
                    enable_screen_share: 1,
                    enable_chat: 1
                },
                recorder: {
                    enable_record_all_formats: 1
                },
                viewer: {
                    enable_all_formats: 1
                }
            },
            basic_pkg: {
                app_manager: {
                    total_sites: 2,
                    total_users: 5,
                    duration: 30,
                    total_storage: 1073741824,
                    storage_type : "LIMITED"

                },
                dashboard: {
                    enable_themes: 0,
                    enable_analytics: 0,
                    enable_updates: 0
                },
                hardware: {
                    enable_android: 1,
                    enable_ios: 0,
                    enable_desktop: 0,
                    enable_hololens: 0,
                    enable_realwear: 1
                },
                features: {
                    enable_workflow: 1,
                    enable_myassist: 0,
                    enable_recorder: 0,
                    enable_viewer: 0
                },
                workflow: {
                    workflow_total: 5,
                    workflow_steps_total: 5,
                    enable_evidence: 1,
                    enable_local_save: 1,
                    enable_without_watermark: 1
                },
                myassist: {
                    enable_con_call: 1,
                    enable_annotation: 1,
                    enable_screen_share: 1,
                    enable_chat: 1
                },
                recorder: {
                    enable_record_all_formats: 1
                },
                viewer: {
                    enable_all_formats: 1
                }
            },
            standred_pkg: {
                app_manager: {
                    total_sites: 2,
                    total_users: 5,
                    duration: 30,
                    total_storage: 1073741824,
                    storage_type : "LIMITED"

                },
                dashboard: {
                    enable_themes: 0,
                    enable_analytics: 0,
                    enable_updates: 0
                },
                hardware: {
                    enable_android: 1,
                    enable_ios: 0,
                    enable_desktop: 0,
                    enable_hololens: 0,
                    enable_realwear: 1
                },
                features: {
                    enable_workflow: 1,
                    enable_myassist: 0,
                    enable_recorder: 0,
                    enable_viewer: 0
                },
                workflow: {
                    workflow_total: 5,
                    workflow_steps_total: 5,
                    enable_evidence: 1,
                    enable_local_save: 1,
                    enable_without_watermark: 1
                },
                myassist: {
                    enable_con_call: 1,
                    enable_annotation: 1,
                    enable_screen_share: 1,
                    enable_chat: 1
                },
                recorder: {
                    enable_record_all_formats: 1
                },
                viewer: {
                    enable_all_formats: 1
                }
            },
            // getLicenseObj: false
        }

    }
    componentDidMount() {
        document.getElementsByClassName('xp-rightbar')[0].style.marginLeft = "0px"
        this.getLocation()
    }
    getLocation = () => {
        var data = {}

        let _this = this;
        axios.post(`${SERVER_IP}/location/list`, data)
            .then(function (response) {

                if (response.status === 200) {
                    if (response.data.error === false) {
                        if (response.data.locationsList) {
                            _this.setState({ locationsList: response.data.locationsList })
                        }
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.getLocation();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }

    checkRequirement = (name, value) => {

        let errors = this.state.errors;

        switch (name) {
            case 'cname':
                errors.cname =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'c_a_name':
                errors.c_a_name =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'location':
                errors.location =
                    value == "Choose..." || value == 0
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;
            case 'password':
                errors.password =
                    value.length < 8
                        ? 'Password must be 8 characters long!'
                        : '';
                break;
            case 'cpassword':
                errors.password =
                    this.state.password !== value
                        ? 'Password and Confirm Password do not match!'
                        : '';
                break;
            default:
                break;
        }

        this.setState({ errors });
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });

        };
    }
    submit = (e) => {

        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {


        } else {
            swal("Invalid Input ..!!")
            return
        }

        if (this.state.password != this.state.cpassword) {
            swal("Invalid Password ..!!")
            return
        }
        this.createCAdmin()

    }
    createCAdmin = () => {
        let license_obj;
        let data = {
            cooperate_name: this.state.cname,
            name: this.state.c_a_name,
            email: this.state.email,
            phone: this.state.phone,
            logo: this.state.logo,
            city: this.state.city,
            state: this.state.stateAddress,
            zip: this.state.zip,
            address: this.state.address,
            details: this.state.details,
            password: this.state.password,
            location_id: this.state.location == "Choose..." ? 0 : this.state.location,
            simualnis_id: 1,
        }
        if (this.state.packageSelected == "FREE") {
            license_obj = Object.assign(this.state.free_pkg, data)
        }
        else if (this.state.packageSelected == "BASIC") {
            license_obj = Object.assign(this.state.basic_pkg, data)

        } else if (this.state.packageSelected == "STANDRED") {
            license_obj = Object.assign(this.state.standred_pkg, data)
        }

        let _this = this;
        axios.post(`${SERVER_IP}/create/cadmin`, license_obj)
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error === false) {
                        swal(response.data.message)
                        window.location.href = "/login"
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.createCAdmin();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    signUp = (pack) => {
        this.setState({ isPackageSelected: true, packageSelected: pack })
    }
    back = () => {
        this.setState({ isPackageSelected: false, packageSelected: "" })

    }
    render() {
        const { errors } = this.state;

        return (
            this.state.isPackageSelected ?
                <>
                    <div className="xp-contentbar">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card m-b-30">
                                    <div className="card-header">
                                        <div class="form-row">
                                            <div class="col-md-10 col-lg-10">
                                                <h5 className="card-title text-black">Sign Up As Corporate Admin</h5>
                                                {/* <h6 className="card-subtitle">Here’s a quick example to demonstrate Bootstrap’s form styles. Keep reading for documentation on required classes, form layout, and more.</h6> */}
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <div class="xp-breadcrumb">
                                                    <ol class="breadcrumb">
                                                        <button className="btn btn-primary btn-lg active" onClick={this.back}>Back</button>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="form-row">
                                            <div className="form-group  col-md-6">
                                                <label for="exampleInputEmail1">Corporate Name</label>
                                                <input type="text" onChange={this.onChangeInput} name="cname" className="form-control" placeholder="Enter Corporate Name" />
                                                {errors.cname.length > 0 && <span className='text-danger'>{errors.cname}</span>}
                                            </div>
                                            <div className="form-group  col-md-6">
                                                <label for="exampleInputEmail1">Corporate Admin Name</label>
                                                <input type="text" onChange={this.onChangeInput} name="c_a_name" className="form-control" placeholder="Enter Corporate Admin Name" />
                                                {errors.c_a_name.length > 0 && <span className='text-danger'>{errors.c_a_name}</span>}

                                            </div>
                                            {/* <div className="form-group  col-md-6">

                                            <label for="exampleInputEmail1">Upload Logo</label>
                                            <input type="file" onChange={this.handleImageChange} name="logo" className="form-control" placeholder="Upload Logo" accept="image/*" />
                                          
                                            <img src={this.state.logo}></img>
                                        </div> */}
                                            <div class="form-group">
                                                <div class="d-flex align-items-center">
                                                    <div class="img_prev  mr-2">
                                                        <img id="blah" src={this.state.logo == "" ? "http://placehold.it/100" : this.state.logo} class="img-thumbnail" alt="your image" />
                                                    </div>
                                                    <input type="file" onChange={this.handleImageChange} class="form-control-file border" name="file" placeholder="Upload Logo" accept="image/*" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Email</label>
                                                <input type="text" onChange={this.onChangeInput} name="email" className="form-control" placeholder="Enter Email" />
                                                {errors.email.length > 0 && <span className='text-danger'>{errors.email}</span>}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Phone</label>
                                                <input type="number" onChange={this.onChangeInput} name="phone" className="form-control" placeholder="Enter Phone" />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Location</label>
                                            <select class="custom-select" name="location" id="inputGroupSelect01" onChange={this.onChangeInput} >
                                                <option selected>Choose...</option>
                                                {this.state.locationsList.map((list, index) =>
                                                    <option value={list.id}>{list.location_name}</option>
                                                )}
                                            </select>
                                            {errors.location.length > 0 && <span className='text-danger'>{errors.location}</span>}

                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">City</label>
                                                <input type="text" onChange={this.onChangeInput} name="city" className="form-control" placeholder="Enter City Name" />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label for="exampleInputEmail1">State</label>
                                                <input type="text" onChange={this.onChangeInput} name="stateAddress" className="form-control" placeholder="Enter State Name" />
                                            </div>
                                            <div className="form-group col-md-2">
                                                <label for="exampleInputEmail1">ZIP</label>
                                                <input type="number" onChange={this.onChangeInput} name="zip" className="form-control" placeholder="Enter ZIP" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Address</label>
                                            <input type="text" onChange={this.onChangeInput} name="address" className="form-control" placeholder="Enter Address" />
                                        </div>
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Details</label>
                                            <input type="text" onChange={this.onChangeInput} name="details" className="form-control" placeholder="Enter Details" />
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Password</label>
                                                <input type="password" onChange={this.onChangeInput} name="password" className="form-control" placeholder="Enter Password" />
                                                {errors.password.length > 0 && <span className='text-danger'>{errors.password}</span>}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Confirm Password</label>
                                                <input type="password" onChange={this.onChangeInput} name="cpassword" className="form-control" placeholder="Re Enter Password" />
                                                {errors.cpassword.length > 0 && <span className='text-danger'>{errors.cpassword}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" onClick={this.submit} className="btn btn-primary mt-3">Sign up</button>



                            </div>
                        </div>
                    </div>

                </>
                :
                <>
                    <div className="card-header">
                        <div class="form-row">
                            <div class="col-md-10 col-lg-10">
                                <img src={logo} style={{ width: "150px" }} />
                                <br />
                                <h5 className="card-title text-black">Remote Assist</h5>
                                <br />
                                <h6 className="card-subtitle">Simulanis Remote Assist is a cross-platform industry 4.0 productivity application, equipped with a plethora of digital features that provide quick and effective assistance for on-site workers to efficiently perform their tasks.</h6>

                            </div>
                            <div class="col-md-2 col-lg-2">
                                <div class="xp-breadcrumb">
                                    <ol class="breadcrumb">
                                        <button className="btn btn-primary btn-lg active" onClick={() => window.location.href = "login"}>Go To Login</button>
                                    </ol>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div id="pricing-table" class="clear">
                        <div class="plan">
                            <h3>Free trial<span>₹0</span></h3>
                            <div class="signup" onClick={() => this.signUp("FREE")}>Start trial</div>
                            <ul>
                                <li><b>5</b> Users</li>
                                <li><b>5</b> Workflow</li>
                                <li><b>N/A</b> My Assist</li>
                                <li><b>N/A</b> Viewer</li>
                                <li><b>N/A</b> My Recorder</li>
                                <li><b>200 MB</b> Storage</li>
                                <li><b>1 Month</b> Duration</li>
                            </ul>
                        </div>
                        <div class="plan" id="most-popular">
                            <h3>Basic<span>₹29</span></h3>
                            <div class="signup" onClick={() => this.signUp("BASIC")}>Sign up</div>
                            <ul>
                                <li><b>20</b> Users</li>
                                <li><b>20</b> Workflow</li>
                                <li><b>Enabled </b> My Assist</li>
                                <li><b>Enabled</b> Viewer</li>
                                <li><b>Enabled</b> My Recorder</li>
                                <li><b>1 GB</b> Storage</li>
                                <li><b>3 Month</b> Duration</li>
                            </ul>
                        </div>
                        <div class="plan">
                            <h3>Standard<span>₹17</span></h3>
                            <div class="signup" onClick={() => this.signUp("STANDRED")}>Sign up</div>
                            <ul>
                                <li><b>50</b> Users</li>
                                <li><b>200</b> Workflow</li>
                                <li><b>Enabled</b> My Assist</li>
                                <li><b>Enabled</b> Viewer</li>
                                <li><b>Enabled</b> My Recorder</li>
                                <li><b>50 GB</b> Storage</li>
                                <li><b>5 Month</b> Duration</li>
                            </ul>
                        </div>
                        <div class="plan">
                            <h3>Custom<span>₹9</span></h3>
                            <a class="signup" href="">Coming Soon</a>
                            <ul>

                            </ul>
                        </div>
                    </div>
                </>
        )
    }
}
export default BuyNow

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}